//コレクションページ　カテゴリサムネイル表示非表示
jQuery(function ($) {
  // resize the collection_thumb_list Div
  var box = $(".collection_thumb_list");
  var minimumHeight = 175; // max height in pixels
  var initialHeight = box.innerHeight();
  // reduce the text if it's longer than 200px
  if (initialHeight > minimumHeight) {
     box.css('height', minimumHeight);
     $(".read-more-button").show();
  }

  SliderReadMore();

  function SliderReadMore() {
     $(".slide-read-more-button").on('click', function () {
        // get current height
        var currentHeight = box.innerHeight();

        // get height with auto applied
        var autoHeight = box.css('height', 'auto').innerHeight();

        // reset height and revert to original if current and auto are equal
        var newHeight = (currentHeight | 0) === (autoHeight | 0) ? minimumHeight : autoHeight;
        if ($(box).length) {
          var boxTop = box.offset().top;
        }
        box.css('height', currentHeight).animate({
           height: (newHeight)
        })
        $('html, body').animate({
           scrollTop: (boxTop)
        });
       $(".slide-read-more-button").toggle();
     });
  }
});
// 右固定バナー表示
$(function() {
 var rNav = $('.rightside_nav_wrap');
 //スクロールが400に達したらクラスを付与
 $(window).scroll(function () {
  if ($(this).scrollTop() > 400) {
   // rNav.addClass('d-flex');
   rNav.fadeIn();
  } else {
   // rNav.removeClass('d-flex');
   rNav.fadeOut();
  }
 });
});
window.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var rWish = $('#swym-anchor');
    //スクロールが400に達したらクラスを付与
    $(window).scroll(function () {
      if ($(this).scrollTop() > 400) {
      // rNav.addClass('d-flex');
      rWish.fadeIn();
      } else {
      // rNav.removeClass('d-flex');
      rWish.fadeOut();
      }
    });
  }, 1000); // Change the delay time (in milliseconds) as needed
  });

//モバイル下部固定ナビ
$(function () {
   $(window).on("scroll touchmove", function () {
     $(".fix-content--top").stop();
     $(".fix-content--top").css("display", "none").delay(500).fadeIn("fast");
   });
 });
//モバイルフッターアコーディオン
 $(function(){
   //クリックで動く
   $('.menu_title').click(function(){
      $(this).toggleClass('active');
      $(this).next('.menu_list').slideToggle();
   });
});
//モバイルヘッダー位置
function PageTopAnime() {
   var scroll = $(window).scrollTop();
   if (scroll >= 10){//上から200pxスクロールしたら
     $('.header-wrapper').removeClass('movedown');
     $('.header-wrapper').addClass('moveup');
   }else{
     if($('.header-wrapper').hasClass('moveup')){
       $('.header-wrapper').removeClass('moveup');
       $('.header-wrapper').addClass('movedown');
     }
   }
 }
 // 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
   PageTopAnime();/* スクロールした際の動きの関数を呼ぶ*/
 });

//  slick slider 読み込み時縦並び対応
// $("body").bind("DOMNodeInserted", function() {
// 	var $this = $(this).find('.slick-initialized');
// 	window.setTimeout(function(){
//         $this.addClass('finally-loaded');
//     }, 2000);
// });

//メガメニューオープン時背景固定
$(".header__icon--menu").on("click", function () {
  if ($('body').hasClass('overflow-hidden-tablet')) {
      $("html").addClass("overflow-hidden-tablet");
  } else {
      $("html").removeClass("overflow-hidden-tablet");
  }
});

//イベントリスナーの最適化（でバウンスやスロットリングを使用して不要なイベント処理を減らす）
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.querySelector('.header__icon--menu');
  const megaMenu = document.querySelector('.menu-drawer');

  if (menuToggle && megaMenu) {
    menuToggle.addEventListener('click', function() {
      megaMenu.classList.toggle('open');
    });
  }
});

//メガメニューのプリロード
document.addEventListener('DOMContentLoaded', function() {
  const megaMenu = document.querySelector('.menu-drawer');
  if (megaMenu) {
    megaMenu.classList.add('preloaded');
  }
});

jQuery(function($) {
  // 監視対象のノード（body）
  var targetNode = document.body;

  // 監視オプション
  var config = { childList: true, subtree: true };

  // コールバック関数
  var callback = function(mutationsList, observer) {
      for(var mutation of mutationsList) {
          if (mutation.type === 'childList') {
              var $slickInitializedElements = $(mutation.target).find('.slick-initialized');
              if ($slickInitializedElements.length > 0) {
                  window.setTimeout(function() {
                      $slickInitializedElements.addClass('finally-loaded');
                  }, 3000);
              }
          }
      }
  };

  // MutationObserverのインスタンス作成
  var observer = new MutationObserver(callback);

  // 監視の開始
  observer.observe(targetNode, config);
    // initイベントの設定
    $(document).on('init', '.slick-slider', function(event, slick) {
      $(slick.$slider).addClass('finally-loaded');
  });

  // afterChangeイベントの設定
  $(document).on('afterChange', '.slick-slider', function(event, slick, currentSlide) {
      if (!$(slick.$slider).hasClass('finally-loaded')) {
          $(slick.$slider).addClass('finally-loaded');
      }
  });
});